import React from 'react';
import PropTypes from 'prop-types';
import { FormItem, Input } from 'formik-antd';
import { Fieldset } from 'components/form';
import { DB_PREFIX } from '../constants';

const CompanyAdminField = ({ i }) => {
  return (
    <>
      <Fieldset>
        <FormItem
          hasFeedback
          label="First Name"
          name={`${DB_PREFIX}.users[${i}].firstName`}
        >
          <Input
            name={`${DB_PREFIX}.users[${i}].firstName`}
            placeholder="Name"
          />
        </FormItem>

        <FormItem label="Last Name" name={`${DB_PREFIX}.users[${i}].lastName`}>
          <Input
            name={`${DB_PREFIX}.users[${i}].lastName`}
            placeholder="Last name"
          />
        </FormItem>
      </Fieldset>

      <Fieldset>
        <FormItem label="Email" name={`${DB_PREFIX}.users[${i}].email`}>
          <Input
            type="email"
            name={`${DB_PREFIX}.users[${i}].email`}
            placeholder="Admin email"
          />
        </FormItem>

        <FormItem
          label="Mobile phone number"
          name={`${DB_PREFIX}.users[${i}].phone`}
        >
          <Input name={`${DB_PREFIX}.users[${i}].phone`} />
        </FormItem>
      </Fieldset>
    </>
  );
};

CompanyAdminField.propTypes = {
  i: PropTypes.number.isRequired,
};

export default CompanyAdminField;
